// Datos de pago del negocio.

export const PAYMENT_METHODS = {
  CASH: 'efectivo',
  TRANSFER: 'transferencia',
};

export const BANK_TRANSFER = {
  bank: 'Banamex',
  beneficiary: 'La Juanita',
  clabe: '002597702254978328',
  account: '5497832',
  card: '5204166293426997',
};

// Número de WhatsApp para enviar comprobantes (formato internacional, sin '+').
// Dejar vacío ('') para ocultar el botón de WhatsApp.
export const ORDERS_WHATSAPP = '';
